<template>
  <div style="padding:10px;" class="bloc modalShare">
    <form @submit.prevent="handleSubmit">
      <div>
        <h2 style="font-size:14px;">{{ $t("popup.copy") }}</h2>
        <hr />
        <div style="display:flex;flex-wrap:wrap;justify-content:center;">
          <div>
            <p class="bold veryObviousExplanations">
              {{ $t("popup.copyFrom") }}
            </p>
            <!-- <p>Copier des participants de </p> -->
            <b-select
              style="font-size:12px;width:200px;"
              class="mySelects"
              @input="handleSelectOrigin"
              v-model="originInventory"
              :placeholder="$t('popup.selectChoice')"
            >
              <option
                v-for="option in dataInventaires"
                :value="option.id"
                :key="option.id"
                >{{ option.name }}</option
              >
            </b-select>
          </div>
          <div>
            <p style="0 auto;" class="bold veryObviousExplanations">
              {{ $t("popup.copyTo") }}
            </p>
            <!-- <p> vers </p> -->
            <b-select
              style="font-size:12px;width:200px;"
              class="mySelects"
              @input="handleSelectTarget"
              v-model="targetInventory"
              :placeholder="$t('popup.selectChoice')"
            >
              <option
                v-for="option in dataInventaires"
                :value="option.id"
                :key="option.id"
                >{{ option.name }}</option
              >
            </b-select>
          </div>
        </div>
      </div>
      <div
        v-if="this.originInventory !== null && this.targetInventory !== null"
      >
        <h2>{{ $t("popup.explainantions3") }}</h2>
        <b-table
          :data="dataTableParticipants"
          :columns="columns"
          checkable
          :hoverable="true"
          :checked-rows.sync="checkedRows"
          class="table-participants"
        >
          <template slot="empty">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>{{ $t("popup.selectToSee") }}</p>
            </div>
          </template>
        </b-table>
        <input
          style="margin-top:20px;border-radius:0px;font-size:12px;"
          class="button is-success"
          type="submit"
          :value="$t('popup.submit')"
          @click="$parent.close()"
        />
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import EventBus from "../../eventBus";

export default {
  data() {
    let dataTableParticipants = [];
    return {
      dataTableParticipants,
      url_appypack: "https://appypack.fr/",
      columns: [],
      test: [],
      radioChoice: null,
      dataInventaires: null,
      checkedRows: [],
      originInventory: null,
      targetInventory: null,
      origin: null,
      target: null,
      errors: [],
      arrayResponses: [],
      open: false,
    };
  },
  created() {
    this.columns = [
      {
        field: "firstname",
        label: this.$i18n.t("popup.firstName"),
        centered: true,
      },
      {
        field: "lastname",
        label: this.$i18n.t("popup.lastName"),
        centered: true,
      },
      {
        field: "created_at",
        label: this.$i18n.t("popup.testDate"),
        centered: true,
      },
    ];
    this.getInventories();
  },
  props: {
    insight_id: {
      type: Number,
      required: true,
    },
  },
  sockets: {
    connect() {
      if (this.insight_id) {
        var room = "Room_Insight_" + this.insight_id;
        this.$socket.emit("room", room);
      }
    },
    channel(data) {
      data = decodeURIComponent(data);

      data.data.forEach((participant) => {
        participant.profil = JSON.parse(participant.profil);
      });
      if (data.type == "NEW_PARTICIPANT") {
        this.insight_resultats.unshift(data.reponse);
      }
    },
  },
  methods: {
    calcul_pts_color_checkbox(PtsColorsCheckboxs) {
      EventBus.$emit("calcul_pts_color_checkbox", PtsColorsCheckboxs);
    },
    cleanUp() {
      this.dataTableParticipants = [];
      this.originInventory = null;
      this.targetInventory = null;
    },
    handleSelectTarget(e) {
      this.target = e;
      if (this.target === this.origin) {
        this.originInventory = null;
        this.origin = null;
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("popup.noSame"),
        });
      }
    },
    handleSelectOrigin(e) {
      this.dataTableParticipants = [];
      this.origin = e;
      if (this.target === this.origin) {
        this.targetInventory = null;
        this.target = null;
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("popup.noSame"),
        });
      }
      this.getParticipants();
    },

    handleSubmit() {
      this.$store.commit("INSIGHT_IS_LOADING_IMPORT_EXPORT", true);
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .post(
          `${process.env.VUE_APP_URL_SSO_API}insight/participants/${this.target}`,
          this.checkedRows,
          headers
        )
        .then((res) => {
          this.arrayResponses.push(res);
          this.calcul_pts_color_checkbox("PtsColorsCheckboxs");
          this.$store.commit("INSIGHT_IS_LOADING_IMPORT_EXPORT", false);
          this.$buefy.$toast.open({
            type: "is-success",
            message: this.$buefy.$i18n.t("toast.copy.OK"),
          });
        })
        .catch((error) => {
          this.errors.push(error);
          this.$buefy.toast.open({
            type: "is-danger",
            message: this.$buefy.$i18n.t("toast.error"),
          });
        });
    },
    //récupère la liste des inventaires d'où l'admin peut importer des participants
    getInventories() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .get(`${process.env.VUE_APP_URL_SSO_API}insight/insight`)
        .then((response) => {
          this.open = true;
          this.dataInventaires = [];
          response.data.forEach((inventory) => {
            //Tri pour supprimer de la liste l'inventaire sur le quel l'admin se trouve
            // if (inventory.url_moderateur !== this.$route.params.url_moderateur) {
            this.dataInventaires.push(inventory);
            // }
          });
        })
        .catch((error) => {
          this.errors.push(error);
          this.ownerMeeting = "Erreur réseau";
        });
    },
    //récupère le sparticpants d'un inventaire donné
    getParticipants() {
      this.checkedRows = [];
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .get(
          `${process.env.VUE_APP_URL_SSO_API}insight/participants/${this.origin}`
        )
        .then((response) => {
          response.data.forEach((resultat) => {
            let participant = resultat;
            participant.first_name = resultat.firstname;
            participant.last_name = resultat.lastname;
            participant.created_at = resultat.created_at
              .substring(0, 10)
              .split("-")
              .reverse()
              .join("/");
            participant.id = resultat.id;
            participant.insight_id = resultat.insight_id;
            this.dataTableParticipants.push(participant);
            this.checkedRows.push(participant);
          });
        })
        .catch((error) => {
          this.ownerMeeting = "Erreur réseau";
          this.errors.push(error);
        });
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 1;
}
.mySelects {
  bottom: 12px;
}

.veryObviousExplanations {
  text-align: center;
  margin-bottom: 20px;
}

.subtitle {
  margin-top: 10px;
}
h1 {
  font-size: 1.2em;
  font-weight: 800;
  margin: 7px;
}

h2 {
  margin-bottom: 5px;
}
.oneMoreTime * {
  display: inline;
}
.modalShare {
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 30px;
}
.table-participants {
  max-height: 38vh;
  overflow-y: auto;
}
</style>
